import axios from "axios"
const basePath = process.env.VUE_APP_HZMB_GH_BASE_PATH;

/**
 * 個人一戶通登入驗證
 * @param {*} form 
 */
const account = (code, token, serviceType, isFirst = true) => {
    return axios.post(`${basePath}/protected/login/person/account?${code ? `code=${code}`:`token=${token}`}&serviceType=${serviceType}${!isFirst ? `&isFirst=${isFirst}` : ''}`).then(res => res)
}

/**
 * 個人手機號碼登入驗證
 * @param {*} form 
 */
const mobile = (serviceType, spNo, registrationNo, identificationNo, identityNo, mobile, captcha, isFirst = true) => {
    return axios.post(`${basePath}/protected/login/person/mobile?serviceType=${serviceType}&${spNo ? `spNo=${spNo}` : `registrationNo=${registrationNo}&identificationNo=${identificationNo}`}&identityNo=${identityNo}&mobile=${mobile}&captcha=${captcha}${!isFirst ? `&isFirst=${isFirst}` : ''}`).then(res => res.headers)
}

/**
 * 公司手機號碼登入驗證
 * @param {*} form 
 */
const company = (serviceType, spNo, registrationNo, identificationNo, companyType, companyNo, mobile, captcha, isFirst = true) => {
    return axios.post(`${basePath}/protected/login/company/mobile?serviceType=${serviceType}&${spNo ? `spNo=${spNo}` : `registrationNo=${registrationNo}&identificationNo=${identificationNo}`}&companyType=${companyType}&companyNo=${companyNo}&mobile=${mobile}&captcha=${captcha}${!isFirst ? `&isFirst=${isFirst}` : ''}`).then(res => res.headers)
}

/**
 * 公司一戶通登入驗證
 * @param {*} form 
 */
 const entityAccount = (code, token, serviceType, isFirst = true) => {
    return axios.post(`${basePath}/protected/login/company/account?${code ? `code=${code}`:`token=${token}`}&serviceType=${serviceType}${!isFirst ? `&isFirst=${isFirst}` : ''}`).then(res => res)
}

/**
 * 手機號碼登入驗證
 * @param {*} serviceType
 * @param {*} mobile
 * @param {*} captcha
 * @param {*} registrationNo
 * @param {*} identificationNo
 */
const mobileCheck = (
  serviceType,
  mobile,
  captcha,
  registrationNo,
  identificationNo
) => {
  return axios
    .post(`${basePath}/protected/login/person/mobile`, null, {
      params: {
        serviceType,
        mobile,
        captcha,
        registrationNo,
        identificationNo,
      },
    })
    .then((res) => res.headers);
};
  
/**
 * 圖形-檢查車輛信息圖形驗證碼-驗證碼
 */
const checkVehicle = () => {
    return axios.get(`${basePath}/public/captcha/graph/check-vehicle`, {
        responseType: "arraybuffer"
    }).then(res => res.data)
}

/**
 * 登錄-手機驗證碼
 * @param {*} mobile 
 * @param {*} serviceType 
 * @param {*} spNo 
 * @param {*} registrationNo 
 * @param {*} identificationNo 
 * @param {*} taxiCertNo 
 * @param {*} identityNo 
 * @returns 
 */
const captcha = (mobile, serviceType, spNo, registrationNo = null, identificationNo = null, taxiCertNo = null, identityNo = null, approveNo = null) => {
    return axios.get(`${basePath}/public/captcha/login/mobile?mobile=${mobile}&serviceType=${serviceType}&${spNo ? `spNo=${spNo}`:`${taxiCertNo ? `taxiCertNo=${taxiCertNo}`:`registrationNo=${registrationNo}&identificationNo=${identificationNo}`}`}${identityNo ? `&identityNo=${identityNo}`:''}${approveNo ? `&approveNo=${approveNo}`:''}`).then(res => res.headers)
}

/**
 * 登出
 */
const logout = () => {
    return axios.get(`${basePath}/protected/logout`).then(res => res.headers)
}

export default {
    account,
    mobile,
    mobileCheck,
    company,
    entityAccount,
    checkVehicle,
    captcha,
    logout
}